import CreateQrEditorStep from '~/pages/CreateQR/components/CreateQrEditorStep';
import CreateQrFinishStep from '~/pages/CreateQR/components/CreateQrFinishStep';
import CreateQrTemplateStep from '~/pages/CreateQR/components/CreateQrTemplateStep';
import useBuilderStore from '~/store/useBuilderStore';

type CreateQrMainProps = {
  isNewQrFlow: boolean;
};

export default function CreateQrMain({ isNewQrFlow }: CreateQrMainProps) {
  const { activeStep } = useBuilderStore();

  if (activeStep === 0) {
    return <CreateQrTemplateStep />;
  }

  if (isNewQrFlow || activeStep === 1) {
    return <CreateQrEditorStep />;
  }

  if (activeStep === 2 || activeStep === 3) {
    return <CreateQrFinishStep />;
  }

  return null;
}
